import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, BookOpenIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-tennis-green text-white overflow-hidden flex flex-col min-h-[100svh] lg:min-h-0 lg:pt-24 lg:pb-16" data-id="element-136">
      <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1595435934249-5df7ed86e1c0?q=40&w=1000&auto=format&fit=crop')] bg-cover bg-center mix-blend-overlay" data-id="element-137"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 flex-1 flex flex-col justify-center w-full py-4 lg:py-0" data-id="element-138">
        <motion.div className="text-center flex flex-col items-center" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-139">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1 lg:px-4 lg:py-1.5 text-[10px] lg:text-sm font-bold tracking-wider text-ball-yellow mb-3 lg:mb-6 uppercase" data-id="element-140">
            PROFE LISTO · TENIS 360
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-display leading-[1.05] mb-4 lg:mb-10 text-white" data-id="element-141">
            Todo tu año de tenis resuelto de una vez.
          </h1>

          {/* Product image between H1 and H2 */}
          <motion.div className="relative w-full max-w-[200px] sm:max-w-xs lg:max-w-2xl mx-auto mb-4 lg:mb-10" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-142">
            {/* Decorative glow behind product */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-143">
              <div className="w-3/4 h-3/4 bg-ball-yellow rounded-full blur-3xl opacity-20" data-id="element-144"></div>
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-ball-yellow rounded-full blur-3xl opacity-30" data-id="element-145"></div>
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-clay-orange rounded-full blur-3xl opacity-30" data-id="element-146"></div>

            <img src="https://cdn.magicpatterns.com/uploads/ngQ1iFwCpdNKGgQXgTgsgg/350.png" alt="Megapack TENIS 360 — Colección completa con 12 Tomos, 6 Bonus y 2 Ebooks Elite" className="relative w-full h-auto drop-shadow-2xl" width={700} height={875} loading="eager" decoding="async" fetchpriority="high" data-id="element-147" />
          </motion.div>

          <h2 className="text-sm sm:text-base md:text-xl lg:text-2xl text-gray-200 mb-4 lg:mb-8 font-medium max-w-2xl mx-auto leading-snug" data-id="element-148">
            Megapack TENIS 360 — El sistema completo de clases, drills y
            planificación para el profesor de tenis argentino
          </h2>

          <div className="flex flex-wrap justify-center gap-2 lg:gap-4 mb-4 lg:mb-10" data-id="element-149">
            <div className="flex items-center gap-1.5 lg:gap-2 bg-white/10 px-2 py-1 lg:px-3 lg:py-2 rounded-lg text-[11px] lg:text-sm font-medium" data-id="element-150">
              <FileTextIcon size={14} className="text-ball-yellow lg:hidden" data-id="element-151" />
              <FileTextIcon size={18} className="text-ball-yellow hidden lg:block" data-id="element-152" />
              <span data-id="element-153">PDF</span>
            </div>
            <div className="flex items-center gap-1.5 lg:gap-2 bg-white/10 px-2 py-1 lg:px-3 lg:py-2 rounded-lg text-[11px] lg:text-sm font-medium" data-id="element-154">
              <ZapIcon size={14} className="text-ball-yellow lg:hidden" data-id="element-155" />
              <ZapIcon size={18} className="text-ball-yellow hidden lg:block" data-id="element-156" />
              <span data-id="element-157">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-1.5 lg:gap-2 bg-white/10 px-2 py-1 lg:px-3 lg:py-2 rounded-lg text-[11px] lg:text-sm font-medium" data-id="element-158">
              <BookOpenIcon size={14} className="text-ball-yellow lg:hidden" data-id="element-159" />
              <BookOpenIcon size={18} className="text-ball-yellow hidden lg:block" data-id="element-160" />
              <span data-id="element-161">12 Tomos + 6 Bonus + 2 Elite</span>
            </div>
          </div>

          <a href="#precio" className="inline-block w-full sm:w-auto bg-clay-orange hover:bg-clay-dark text-white font-display text-base sm:text-lg md:text-xl lg:text-2xl py-3.5 px-6 lg:py-5 lg:px-8 rounded-xl shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-162">
            💪 QUIERO MI TENIS 360 AHORA
          </a>
        </motion.div>
      </div>

      {/* Trust badges row — sits below the visible CTA fold on mobile */}
      <div className="relative z-10 px-4 pb-6 lg:pb-0 lg:mt-6" data-id="element-163">
        <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-3 lg:gap-4 text-[10px] lg:text-xs text-gray-300 font-medium" data-id="element-164">
          <div className="flex items-center gap-1.5" data-id="element-165">
            <ShieldCheckIcon size={14} data-id="element-166" />
            <span data-id="element-167">Garantía 7 días</span>
          </div>
          <span className="opacity-30" data-id="element-168">|</span>
          <div className="flex items-center gap-1.5" data-id="element-169">
            <LockIcon size={14} data-id="element-170" />
            <span data-id="element-171">Pago seguro</span>
          </div>
          <span className="opacity-30" data-id="element-172">|</span>
          <div className="flex items-center gap-1.5" data-id="element-173">
            <CreditCardIcon size={14} data-id="element-174" />
            <span data-id="element-175">Tarjetas y transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}